import type { SmartHomeUiCopy } from '../api';

export type SmartHomeEcosystemView = {
  id: string;
  name: string;
  icon: string;
  color: string;
  gradient: string;
  tagline: string;
  protocols: string[];
  description: string;
  howTo: string[];
  requirements?: string[];
  limitations?: string[];
};

export type SmartHomeProtocolView = {
  id: string;
  name: string;
  glowColor: string;
  desc: string;
};

const ECO_VISUAL: Record<string, { color: string; gradient: string }> = {
  xiaomi: { color: 'text-orange-700', gradient: 'from-orange-400 to-red-500' },
  tuya: { color: 'text-cyan-700', gradient: 'from-cyan-400 to-blue-500' },
  alice: { color: 'text-yellow-700', gradient: 'from-yellow-400 to-orange-500' },
  matter: { color: 'text-green-700', gradient: 'from-green-400 to-emerald-600' },
  homeassistant: { color: 'text-indigo-700', gradient: 'from-indigo-400 to-purple-600' },
  wirenboard: { color: 'text-gray-700', gradient: 'from-gray-500 to-slate-700' },
};

const PROTOCOL_GLOW: Record<string, string> = {
  wifi: 'rgba(99,179,237,0.2)',
  zigbee: 'rgba(159,122,234,0.2)',
  matter: 'rgba(72,187,120,0.2)',
  rs485: 'rgba(255,255,255,0.08)',
};

export function mapSmartHomeUiToView(data: SmartHomeUiCopy): {
  page: SmartHomeUiCopy['page'];
  ecosystems: SmartHomeEcosystemView[];
  protocols: SmartHomeProtocolView[];
  chooser: SmartHomeUiCopy['chooser'];
} {
  return {
    page: data.page,
    chooser: data.chooser,
    ecosystems: data.ecosystems.map((eco) => {
      const vis = ECO_VISUAL[eco.id] ?? { color: 'text-gray-700', gradient: 'from-gray-500 to-slate-700' };
      return {
        id: eco.id,
        name: eco.name,
        icon: eco.icon,
        color: vis.color,
        gradient: vis.gradient,
        tagline: eco.tagline,
        protocols: eco.protocols,
        description: eco.description,
        howTo: eco.how_to,
        requirements: eco.requirements?.length ? eco.requirements : undefined,
        limitations: eco.limitations?.length ? eco.limitations : undefined,
      };
    }),
    protocols: data.protocols.map((p) => ({
      id: p.id,
      name: p.name,
      glowColor: PROTOCOL_GLOW[p.id] ?? PROTOCOL_GLOW.wifi,
      desc: p.desc,
    })),
  };
}
